import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SCREEN_TYPE_DRIVER_MANAGEMENT } from '@utils/constants/enums';

const initialState: DriverManagementState = {
  screenModeDriver: SCREEN_TYPE_DRIVER_MANAGEMENT.list,
};

const reducers = {
  setScreenModeDriver: (
    state: DriverManagementState,
    action: PayloadAction<SCREEN_TYPE_DRIVER_MANAGEMENT>
  ) => {
    state.screenModeDriver = action.payload;
  },
  setInit: () => initialState,
};

export const driverManagementSlice = createSlice({
  name: 'driverManagement',
  initialState,
  reducers,
});
export const { setScreenModeDriver, setInit } = driverManagementSlice.actions;

export default driverManagementSlice.reducer;
